const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
/**
 * Format a byte count as a human-readable string (e.g. `1.5 MB`).
 */
export function formatBytes(bytes, fractionDigits = 1) {
    if (!Number.isFinite(bytes) || bytes < 0) {
        throw new RangeError('bytes must be a non-negative finite number');
    }
    if (bytes === 0) {
        return '0 B';
    }
    const exp = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), BYTE_UNITS.length - 1);
    const value = bytes / 1024 ** exp;
    const unit = BYTE_UNITS[exp];
    if (exp === 0) {
        return `${Math.round(value)} ${unit}`;
    }
    const rounded = Number(value.toFixed(fractionDigits));
    return `${rounded} ${unit}`;
}
/**
 * Format a duration in milliseconds as `H:MM:SS` or `M:SS`.
 */
export function formatDuration(ms) {
    if (!Number.isFinite(ms) || ms < 0) {
        throw new RangeError('ms must be a non-negative finite number');
    }
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const mm = String(minutes).padStart(hours > 0 ? 2 : 1, '0');
    const ss = String(seconds).padStart(2, '0');
    if (hours > 0) {
        return `${hours}:${mm.padStart(2, '0')}:${ss}`;
    }
    return `${minutes}:${ss}`;
}
//# sourceMappingURL=format.js.map